export { default as setLanguageToStorage } from "./setLanguageToStorage";
